export const setStorage = (key, value) => {
  if (!key) return;


  const data = typeof value === "object" ? JSON.stringify(value) : value;

  localStorage.setItem(key, data);
};

export const getStorage = (key) => {
  if (!key) return null;

  const value = localStorage.getItem(key);

  try {
    return JSON.parse(value); 
  } catch {
    return value; 
  }
};

export const removeStorage = (key) => {
  if (!key) return;

  localStorage.removeItem(key);
};